import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MasterLayout from "./MasterLayout";
import HomePage from "./HomePage";
import EventCalendarSection from "./EventCalendarSection";
import GalleryPage from "./GalleryPage";  // <- adjust path as needed
import KshetraResultPage from "./KshetraResultPage";
import ManagementPage from "./ManagementPage"; // <-- adjust path if needed
import AboutVBKPPage from "./AboutVBKPPage";
import AffiliatedUnitPage from "./AffiliatedUnitPage";
import KshetraDetailPage from "./KshetraDetailPage";


function App() {
  return (
    <Router>
      <Routes>
        {/* Layout route */}
        <Route path="/" element={<MasterLayout />}>
          <Route index element={<HomePage />} />
          <Route path="calendar" element={<EventCalendarSection />} />
          <Route path="gallery" element={<GalleryPage />} />
          <Route path="kshetra-results" element={<KshetraResultPage />} />
          <Route path="management" element={<ManagementPage />} />
          <Route path="about-vbkp" element={<AboutVBKPPage />} />
          <Route path="affiliated-units" element={<AffiliatedUnitPage />} />
          <Route path="/kshetra/:remark" element={<KshetraDetailPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
